<template>
    <main-layout>

        <app-header icon="factory">
            Installations
        </app-header>

        <action-bar :back="{name: 'liste-detenteurs'}">
            <a class="btn add btn-full" id="main-action" href="javascript: void 0" @click.prevent="addInstallation">
                <i class="icon-add"></i>
                <strong>Ajouter</strong> une installation
            </a>
        </action-bar>


        <filter-bar @searchBarChanged="updateSearch" :gotFilter="true" filterText="Installation avec fluide"
                    @filterValChanged="changeList" placeholderFilter="Rechercher par Nom" type-history="installation">
        </filter-bar>

        <div class="list-installations list" v-show="listVisible === 'fluide'">
            <installation-item v-for="installation in filterListFluide" :key="installation.id" :installation="installation"></installation-item>
        </div>

        <div class="list-installations list" v-show="listVisible === 'noFluide'">
            <installation-item v-for="installation in filterListNoFluide" :key="installation.id" :installation="installation"></installation-item>
        </div>

    </main-layout>
</template>

<script>
    import InstallationItem from './InstallationItem.vue'
    import Installation from '../../js/models/Installation'

    export default {
        data() {
            return {
                installations: [],
                strSearch: '',
                listVisible: 'fluide',
            }
        },
        computed: {
            filterListFluide() {
                if (!_.isEmpty(this.installations)) {

                    return this.installations.filter(install => {
                        let check = false;
                        if (install.marque && install.marque.toLowerCase().includes(this.strSearch)){
                            check = true
                        }
                        if (install.modele && install.modele.toLowerCase().includes(this.strSearch)){
                            check = true
                        }
                        if (_.has(install, 'nom') && install.nom && install.nom.toLowerCase().includes(this.strSearch)) {
                            check = true
                        }
                        if (_.has(install, 'fluide') && !_.isEmpty(install.fluide) && install.fluide.nom) {
                            if (install.fluide.nom.toLowerCase().includes(this.strSearch)) {
                                check = true
                            }
                        }

                        if(install.hasOwnProperty('custom') && install.custom !== null && install.custom.toLowerCase().includes(this.strSearch)) {
                           check = true
                        }

                        if (check === true && _.has(install, 'fluide') && !_.isEmpty(install.fluide)) {
                            return install
                        }
                    })
                }
            },

            filterListNoFluide(){
                if (!_.isEmpty(this.installations)) {

                    return this.installations.filter(install => {
                        let check = false;
                        if (install.marque && install.marque.toLowerCase().includes(this.strSearch)){
                            check = true
                        }
                        if (install.modele && install.modele.toLowerCase().includes(this.strSearch)){
                            check = true
                        }
                        if (_.has(install, 'nom') && install.nom && install.nom.toLowerCase().includes(this.strSearch)) {
                            check = true
                        }
                        if (_.has(install, 'fluide') && !_.isEmpty(install.fluide)) {
                            check = false
                        }
                        if (check === true) {
                            return install
                        }
                    })

                }

            }

        },
        methods: {
            fetchInstallations() {
                let idDet = this.$route.params.id;
                Installation
                    .getInstallationsForDet(idDet)
                    .then( data => {
                        this.installations = _.sortBy(data, [install => install.nom.toUpperCase()])
                    })
                    .catch()
            },
            addInstallation(){
                let idDet = this.$route.params.id;
                if (JSON.parse(localStorage.getItem('canEditInstallations')) === true) {
                    Installation.askAddInstall(idDet);
                } else {
                    swal('Action non autorisée', "Vous n'avez pas le droit d'ajouter d'installations, veuillez contacter votre administrateur", 'error')
                }
            },
            updateSearch(str) {
                this.strSearch = String(str[0]).toLowerCase()
            },
            changeList(filter){
                if(filter === false){
                    this.listVisible = 'noFluide'
                } else {
                    this.listVisible = 'fluide'
                }
            }
        },
        mounted: function () {
            this.fetchInstallations()

        },
        components: {
            InstallationItem
        }
    }

</script>




// WEBPACK FOOTER //
// ListeInstallations.vue?aef02d48